import {charcoal} from '../sass/base/_exports.sass';

export const IntersectionIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox="0 0 31 31"
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91669 20H10.6667V23.75C10.6667 25.1287 11.7879 26.25 13.1667 26.25H24.4167C25.7954 26.25 26.9167 25.1287 26.9167 23.75V12.5C26.9167 11.1213 25.7954 10 24.4167 10H20.6667V6.25C20.6667 4.87125 19.5454 3.75 18.1667 3.75H6.91669C5.53794 3.75 4.41669 4.87125 4.41669 6.25V17.5C4.41669 18.8787 5.53794 20 6.91669 20ZM18.1679 17.5L18.1667 12.5H18.1679V17.5ZM24.4167 12.5L24.4179 23.75H13.1667V20H18.1667C19.5454 20 20.6667 18.8787 20.6667 17.5V12.5H24.4167ZM6.91669 6.25H18.1667V10H13.1667C11.7879 10 10.6667 11.1213 10.6667 12.5V17.5H6.91669V6.25Z"
        fill={color}
      />
    </svg>
  );
};
